import { Grid } from '@mui/material';
import flightsImageMobile from '@shared/assets/mobileFlights.png';
import flightsImage from '@shared/assets/backgroundFlights.svg';
import assistImageMobile from '@shared/assets/assistSearchMobile.svg';
import assistImage from '@shared/assets/assistSearch.svg';
import hotelsImageMobile from '@shared/assets/mobileHotels.svg';
import hotelsImage from '@shared/assets/backgroundHotels.svg';
import { ID_SITE } from '@shared/conf/env';

const id_site = Number(ID_SITE);

const imageUrls = {
  0: { desktop: flightsImage, mobile: flightsImageMobile },
  1: { desktop: hotelsImage, mobile: hotelsImageMobile },
  2: { desktop: assistImage, mobile: assistImageMobile },
};

function getBackgroundStyles(searchType) {
  if (id_site === 2) {
    return {
      backgroundImage: 'none',
      backgroundColor: 'white',
    };
  }

  const { mobile, desktop } = imageUrls[searchType];

  return {
    backgroundImage: {
      xs: `url(${mobile})`,
      sm: `url(${desktop})`,
    },
    backgroundColor: 'transparent',
  };
}

export function GridMainContainer({
  searchType = 0,
  children,
  sxGrid,
  ...props
}) {
  return (
    <Grid
      container
      {...props}
      sx={{
        width: '100%',
        display: 'flex',
        placeItems: 'center',
        justifyContent: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        ...getBackgroundStyles(searchType),
        ...sxGrid,
      }}
    >
      {children}
    </Grid>
  );
}

// Reutilizable sxStyle
export const sxStyle = {
  root: {
    width: { xs: '100%', sm: '60%' },
    maxWidth: '800px',
    my: { xs: 2, sm: 4 },
    backgroundColor: '#FFFFFFCC',
    borderRadius: '8px',
    border: 'solid 1px #d6d6d6',
  },
  gridPadding: {
    padding: { xs: '14px', sm: '40px' },
    borderRadius: '8px',
  },
  typographyBoxError: {
    fontSize: { xs: '16px', sm: '24px' },
    fontWeight: 400,
    color: '#000000',
    lineHeight: 1,
  },
  bookingDetailTitle: {
    fontSize: { xs: '14px', sm: '26px' },
    fontWeight: { xs: 600, sm: 700 },
    color: '#000',
  },
  bookingDetailSubtitle: {
    fontSize: { xs: '12px', sm: '20px' },
    color: '#000',
  },
  gridContainer: {
    width: '100%',
    marginTop: { xs: '10px', sm: '20px' },
  },
  status: {
    fontFamily: 'Open Sans, sans-serif',
    width: '100%',
    textAlign: 'center',
    borderStartStartRadius: '8px',
    borderStartEndRadius: '8px',
    placeItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    color: '#FFFFFF',
    fontSize: { xs: '16px', sm: '20px' },
    fontWeight: 600,
    height: { xs: '35px', sm: '50px' },
  },
  gridBookingDetail: {
    border: '1px solid #636466',
    borderTop: 'none',
    borderEndEndRadius: '8px',
    borderEndStartRadius: '8px',
  },
  gridItemBookingDetailHotel: {
    borderBottom: '1px solid #636466',
    padding: { xs: '10px', sm: '20px' },
    textAlign: 'center',
  },
  gridItemBookingDetailOnlyHotel: {
    padding: { xs: '10px', sm: '20px' },
    textAlign: 'center',
  },
  bookingDetailText: {
    color: '#000',
    fontSize: { xs: '14px', sm: '18px' },
    paddingBottom: '8px',
  },
};
